(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeChiefComplaintComponent', psychIntakeChiefComplaintComponent);

    psychIntakeChiefComplaintComponent.$inject = [];

    function psychIntakeChiefComplaintComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeChiefComplaintController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/chief-complaint.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeChiefComplaintController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeChiefComplaintController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();
        
        vm.disabledCheck = function(item) {
            if ($scope.vm.workflow.answer && $scope.vm.workflow.answer.currentSymptomsSelected) {
                var selected = $scope.vm.workflow.answer.currentSymptomsSelected;
                if (item === 'NONE') {
		        	var symptoms = ['ANXIETY', 'DEPRESSION', 'SLEEP_PROBLEMS', 'IRRITABILITY_ANGER', 'PANIC_ATTACKS', 'NIGHTMARES_FLASHBACKS', 'OTHER'];
			        return symptoms.some(function(symptom) {
			            return selected[symptom];
			        });
		        } else {
		        	return selected['NONE'];
		        }
            } else {
            	return false;
            }
        }
    }
})();
